module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAWBAMAAABeafMwAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUxpcTExMy8vLy8vMy4uLjAwMzExMi8vMjExMzExMi8vMTExM4FqbIIAAAALdFJOUwDfIIAQoM+Q77+AalTABgAAAIZJREFUeNp9zzEOgkAQheEJSjSWtjZ4A3saKmp7WjqOwEW8BiFoyF7OhZfx32zhFJO8l6+YsX9TvJYq7+4hXHN2C2FyCAPCfhAGhAFhc+0Q9jg4hJml8Lgzsx026loxwV5sEBN8NwkDwoBiH79gFNzY07syhtVOcS981MVoZzGgOjGgXZwBv1s9YhHc9FmFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/per1 (37).png
// module id = 8HfZ
// module chunks = 1